import { InputTypes, dynamicInputType } from '.';

export const dynamicInputListConfig: dynamicInputType[] = [
  { name: 'comments', label: 'Razor Comments', type: InputTypes.TEXT_AREA },
  { name: 'workOrderId', label: 'Work Order ID', type: InputTypes.INPUT },
  { name: 'orderType', label: 'Order Type', type: InputTypes.INPUT },
  { name: 'actualWorkDescription', label: 'Work Description', type: InputTypes.TEXT_AREA },
  { name: 'equipmentNumber', label: 'Equipment Number', type: InputTypes.INPUT },
  { name: 'componentName', label: 'Component Name', type: InputTypes.INPUT },
  { name: 'maintenanceActivityType', label: 'Maintenance Activity Type', type: InputTypes.INPUT },
  {
    name: 'dates',
    label: 'Dates',
    type: InputTypes.INPUT_GROUP,
    inputGroup: [
      { name: 'actualStartDate', label: 'Actual Start Date', type: InputTypes.INPUT },
      { name: 'actualEndDate', label: 'Actual End Date', type: InputTypes.INPUT },
    ],
  },
  { name: 'laborHours', label: 'Labor Hours', type: InputTypes.INPUT },
  { name: 'personResponsible', label: 'Person Responsible', type: InputTypes.INPUT },
  { name: 'priority', label: 'Priority', type: InputTypes.INPUT },
  { name: 'plantNumber', label: 'Plant Number', type: InputTypes.INPUT },
];
